import script from "./Contact.vue?vue&type=script&lang=ts&setup=true"
export * from "./Contact.vue?vue&type=script&lang=ts&setup=true"

import "./Contact.vue?vue&type=style&index=0&id=8f51e82e&lang=scss"

const __exports__ = script;

export default __exports__